/* eslint-disable camelcase */

type Props = {
    readonly id: number;
    readonly value: number;
    readonly preselected?: boolean;
    readonly is_custom_value?: boolean;
};

export default class DepositBoxValue {
    public readonly id: number;
    public readonly value: number;
    public readonly preselected: boolean;
    public readonly is_custom_value: boolean;

    constructor({ id, value, preselected = false, is_custom_value = false }: Props) {
        this.id = id;
        this.value = value;
        this.preselected = preselected;
        this.is_custom_value = is_custom_value;
    }
}
